// For AchieveJUPAS

import firebase from "firebase/compat/app";
import 'firebase/compat/functions';

export default {
  // SNDAS Application
  async upsertSNDASApplication(payload: any) {
    return (await firebase.app().functions('asia-east2').httpsCallable('sndas-upsertSNDASApplication')(payload)).data;
  },

  // Requirements (meet or not)
  async upsertUserSNDASRequirements(userSNDASRequirements: any) {
    return (await firebase.app().functions('asia-east2').httpsCallable('sndas-upsertUserSNDASRequirements')({ userSNDASRequirements })).data;
  },
}